<template>
    <v-card class="elevation-0 rounded-sm">
        <v-card-text>
            <v-row>
                <v-col cols="12" class="d-flex">
                    <h1 style="font-size: 16px;">Listado de tipo de propiedad</h1>
                    <v-spacer></v-spacer>
                    <DefaultButton
                        label="Crear Tipo de Propiedad"
                        variant='outlined'
                        @click="openModal(propertyTypeStore.propertyTypeModalOptions)"
                    />
                </v-col>
                <v-divider></v-divider>
                <v-col cols="12">
                    <DefaultDataTable 
                        ref="PropertyTypeTable"
                        :data-table="dataTable"
                        :filters="filters"
                        @edit="editPropertyType"
                        @delete="deleteResource"
                    />
                </v-col>
            </v-row>
        </v-card-text>
        <PropertyTypeFormModal
            ref="propertyTypeFormModal"
            @confirm="refreshTable(PropertyTypeTable)"
        />
        <DefaultDeleteDialog 
            ref="deleteDialog"
            @deleted="acceptDelete"
        />
    </v-card>    
</template>
<script setup>
    import {ref} from 'vue';
    import DefaultDataTable from '@/components/basics/DefaultDataTable.vue';
    import DefaultButton from '@/components/basics/DefaultButton.vue';
    import { openModal,refreshTable } from '@/composables/modal';
    import PropertyTypeFormModal from './PropertyTypeFormModal'
    import { usePropertyTypeStore } from '@/stores';
    import DefaultDeleteDialog from '@/components/basics/DefaultDeleteDialog.vue';
    const deleteDialog = ref(null);
    const PropertyTypeTable = ref(null);
    const dataTable = {
        endpoint: '/manager/v1/properties/types',
        headers: [
            {title: "Nombre", value: "name", align: 'center', sortable: false},
            {title: "FECHA DE CREACIÓN", value: "created_at", align: 'center', sortable: false},
            {title: "Opciones", value: "actions", align: 'center', sortable: false},
        ],
        actions: [
            {
                text: "Editar",
                icon: 'mdi mdi-pencil',
                type: 'action',
                method_name: 'edit'
            },
            {
                text: "Eliminar",
                icon: 'mdi mdi-delete',
                type: 'action',
                method_name: 'delete'
            }
        ],
        more_actions: [
        ]
    }
    const filters = {
        q: '',
    };
    const propertyTypeStore = usePropertyTypeStore();
    const propertyTypeFormModal = ref(null);
    const editPropertyType = async (property_type)=>{
        await propertyTypeStore.findPropertyType(property_type.id);
        propertyTypeFormModal.value.resetPropertyType();
        openModal(propertyTypeStore.propertyTypeModalOptions,property_type)
    } 
    const deleteResource = (propertyType) =>{
        deleteDialog.value.openDialog(propertyType);
    }
    const acceptDelete = async(propertyType) =>{
        await propertyTypeStore.deletePropertyType(propertyType.id);
        refreshTable(PropertyTypeTable.value);
    }
</script>